import { Spinner } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getScopeRole } from '../../../utils/dataTransformation/role';
import { ETypeUser } from '../../../utils/store/model/store.model';
import navigateParams from '../../../utils/navigation/navigateParams';
import { useGlobalContext } from '../../../context/global-context/GlobalContext';

const LoginSSOCallback: React.FC = () => {
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const { context, setContext } = useGlobalContext();

    const redirectHome = () => {
        const preClient = new URLSearchParams(window.location.search).has('clientType');
        if (preClient) {
            navigate(`/home?clientType=${new URLSearchParams(window.location.search).get('clientType')}`);
        } else {
            getScopeRole()
                .then((response) => {
                    const islight = response === ETypeUser.LIGHT;
                    window.localStorage.setItem('scope', JSON.stringify(response));
                    if (islight) setContext({ ...context, typeUser: response });
                    navigate('/home');
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };
    const sendToNative = (description: string, type: string) => {
        const queryParams = {
            state: description,
            title: t('profileFeedbackErrorTitle'),
            subtitle: t('errorGenericDescription'),
            errorCode: '',
        };
        navigateParams(type, '', queryParams, {}, '');
    };

    useEffect(() => {
        if (params.has('error')) {
            sendToNative('ERROR', 'feedback-error');
        } else {
            if (isAndroid || isIOS) {
                if (!window.Android && !window.webkit) redirectHome();
            } else {
                redirectHome();
            }
        }
    }, []);

    return (
        <>
            <div className='c-spinner'>
                <Spinner size={24} />
                <span className='c-spinner-overlay'></span>
            </div>
        </>
    );
};

export default LoginSSOCallback;
